export default "__VITE_ASSET__4EBaO5fH__"